import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

/**
 * Skeleton per singola riga tabella prodotti.
 * Rispecchia esattamente la struttura di ProdottiList.
 */
function ProdottoRowSkeleton() {
  return (
    <TableRow>
      {/* Immagine */}
      <TableCell>
        <Skeleton className="w-10 h-10 rounded" />
      </TableCell>
      
      {/* Codice */}
      <TableCell>
        <Skeleton className="h-4 w-24" />
      </TableCell>
      
      {/* Nome + descrizione */}
      <TableCell>
        <div className="space-y-1">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3 w-32" />
        </div>
      </TableCell>
      
      {/* Categoria */}
      <TableCell>
        <Skeleton className="h-6 w-20 rounded-full" />
      </TableCell>
      
      {/* Prezzo */}
      <TableCell className="text-right">
        <Skeleton className="h-4 w-16 ml-auto" />
      </TableCell>
      
      {/* Margine */}
      <TableCell className="text-right">
        <Skeleton className="h-4 w-12 ml-auto" />
      </TableCell>
      
      {/* Stato */}
      <TableCell>
        <Skeleton className="h-6 w-16 rounded-full" />
      </TableCell>
      
      {/* Azioni (3 bottoni) */}
      <TableCell className="text-right">
        <div className="flex justify-end gap-2">
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
        </div>
      </TableCell>
    </TableRow>
  )
}

/**
 * Skeleton completo per tabella prodotti.
 * Include header + righe skeleton.
 * 
 * @param {number} rows - Numero di righe skeleton da mostrare (default: 8)
 */
export default function ProdottiTableSkeleton({ rows = 8 }) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-16"></TableHead>
              <TableHead>Codice</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Categoria</TableHead>
              <TableHead>Prezzo</TableHead>
              <TableHead>Margine</TableHead>
              <TableHead>Stato</TableHead>
              <TableHead className="text-right">Azioni</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: rows }).map((_, i) => (
              <ProdottoRowSkeleton key={i} />
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
